import React, {useState} from 'react';
import TopBar from '../../Components/TopBar';
import Page from '../../Components/Containers/Page';
import { useCustomers } from '../../Data/Customers';
import ListViewLoading from '../../Components/EmptyStates/ListViewLoading';
import List from './List';
import { useSearch } from '../../Components/Search';
import EditCustomer from '../Customer/EditCustomer';
import { getEntityLink, useRedirect } from '../../Services/helpers';
import Export from './Export';

const ListView = () => {
    const {searchDebounced, setSearchData} = useSearch();
    const {customers, isEmpty, isLoading, refresh} = useCustomers(searchDebounced, true);
    const [addingCustomer, setAddingCustomer] = useState(false);
    const [exporting, setExporting] = useState(false);
    const {go, Redirect} = useRedirect();

    return <>
        <TopBar title="Customers" dropdownOptions={[
            {
                title: 'Add customer',
                icon: 'Plus',
                onClick: () => setAddingCustomer(true)
            },
            {
                div: true,
            },
            {
                title: 'Archived customers',
                icon: 'BoxArchive',
                onClick: () => setSearchData({deleted: !searchDebounced?.deleted})
            },
            {
                div: true,
            },
            {
                title: 'Export customers',
                icon: 'CloudArrowDown',
                onClick: () => setExporting(true),
            }
        ]} />

        <Page>
            {customers === null && <ListViewLoading count={5} />}
            {customers !== null && <List {...{isLoading, customers,isEmpty, setAddingCustomer}} />}
        </Page>

        <EditCustomer isOpen={addingCustomer}
            onClose={() => setAddingCustomer(false)}
            onSave={(customerId) => {
                refresh();
                go(getEntityLink('Customers/Customer', customerId));
            }}
        />

        <Export isOpen={exporting} setIsOpen={setExporting} />

        <Redirect />
    </>
}

export default ListView;
